import { inject, Injectable } from '@angular/core';
import { AutenticacaoResponse } from '@modules/auth/models/autenticacao';
import { AuthService } from '@modules/auth/services/auth.service';
import { TokenService } from '@modules/auth/services/token.service';
import { ApiService } from '@shared/services/api.service';
import { catchError, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private readonly _endpoint = '/tenants';
  private readonly _apiService = inject(ApiService);
  private readonly _tokenService = inject(TokenService);
  private readonly _authService = inject(AuthService);

  switchTenant(tenantId: string) {
    const refreshToken = this._tokenService.getRefreshToken();
    return this._apiService
      .post<AutenticacaoResponse>(`/autenticacao${this._endpoint}/switch`, {
        tenantId,
        refreshToken,
      })
      .pipe(
        tap((response) => {
          this._tokenService.saveTokens(response.accessToken, response.refreshToken);
          this._authService.estaAutenticado$ = true;
          this._authService.configurarAtualizacaoAutomaticaToken();
        }),
        catchError((error) => throwError(() => error)),
      );
  }
}
